var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.groups.length || _vm.workspaceFilterActive
    ? _c(
        "div",
        { staticClass: "vks-mapping-bar" },
        [
          _vm._m(0),
          _c("div", { staticClass: "vks-mapping-bar-controls" }, [
            _c("label", { staticClass: "vks-mapping-bar-mode" }, [
              _vm._v(" Compare mapped features: "),
              _c(
                "select",
                {
                  staticClass: "vks-mapping-bar-select",
                  domProps: { value: _vm.mappingMode },
                  on: { change: _vm.onModeChange },
                },
                _vm._l(_vm.modeOptions, function (option) {
                  return _c(
                    "option",
                    { key: option.id, domProps: { value: option.id } },
                    [_vm._v(" " + _vm._s(option.label) + " ")]
                  )
                }),
                0
              ),
            ]),
            _c(
              "div",
              { staticClass: "vks-ui-btn-row vks-mapping-bar-actions" },
              [
                _c(
                  "button",
                  {
                    staticClass: "vks-ui-btn vks-ui-btn--secondary",
                    attrs: { type: "button", disabled: !_vm.categories.length },
                    on: { click: _vm.selectAll },
                  },
                  [_vm._v(" Select all ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "vks-ui-btn vks-ui-btn--secondary",
                    attrs: {
                      type: "button",
                      disabled: !_vm.selectedCategoryIds.length,
                    },
                    on: { click: _vm.clearAll },
                  },
                  [_vm._v(" Clear mapping ")]
                ),
                _c("label", { staticClass: "vks-mapping-bar-toggle" }, [
                  _c("input", {
                    attrs: {
                      type: "checkbox",
                      disabled:
                        !_vm.workspaceFilterActive &&
                        !_vm.selectedCategoryIds.length,
                    },
                    domProps: { checked: _vm.workspaceFilterActive },
                    on: { change: _vm.onWorkspaceFilterToggle },
                  }),
                  _c("span", [_vm._v("Filter workspace to mapped data")]),
                ]),
              ]
            ),
          ]),
          _vm.workspaceFilterActive
            ? _c("p", { staticClass: "vks-mapping-bar-applied" }, [
                _vm._v(
                  " Workspace filter on: " +
                    _vm._s(_vm.workspaceFilterRowCount.toLocaleString()) +
                    " mapped variant(s) driving visualizers. Turn off to restore the full workspace view. "
                ),
              ])
            : _vm._e(),
          _vm._l(_vm.groups, function (group) {
            return _c(
              "section",
              { key: group.id, staticClass: "vks-mapping-bar-group" },
              [
                _c("p", { staticClass: "vks-ui-section-title" }, [
                  _vm._v(_vm._s(group.label)),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "vks-mapping-bar-chips",
                    attrs: { role: "group", "aria-label": group.label },
                  },
                  _vm._l(group.categories, function (category) {
                    return _c(
                      "div",
                      {
                        key: category.id,
                        staticClass: "vks-mapping-bar-chip",
                        class: { "is-selected": _vm.isSelected(category.id) },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "vks-mapping-bar-chip-toggle",
                            attrs: {
                              type: "button",
                              "aria-pressed": _vm.isSelected(category.id)
                                ? "true"
                                : "false",
                              title: _vm.isSelected(category.id)
                                ? "Cancel mapping for this option"
                                : "Apply mapping for this option",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleCategory(category.id)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(category.label) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "vks-mapping-bar-chip-remove",
                            attrs: {
                              type: "button",
                              "aria-label": `Remove ${category.label}`,
                              title: "Remove this option",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.removeCategory(category.id)
                              },
                            },
                          },
                          [_vm._v(" × ")]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "vks-mapping-bar-intro" }, [
      _vm._v(" Mapping has three layers that stay independent: "),
      _c("strong", [_vm._v("loaded workspace data")]),
      _vm._v(", "),
      _c("strong", [_vm._v("mappable options")]),
      _vm._v(" (chips below — checked or not), and an optional "),
      _c("strong", [_vm._v("Filter workspace to mapped data")]),
      _vm._v(
        " view. Filtering only changes what visualizers render; it does not rewrite loaded data or clear your mapping/track selections. "
      ),
      _c("strong", [_vm._v("Or")]),
      _vm._v(" keeps variants that match any checked category; "),
      _c("strong", [_vm._v("And")]),
      _vm._v(
        " keeps only variants that match every checked category. Turn the filter off to restore the full workspace view with the same selections. Click a chip to apply or cancel mapping; click "
      ),
      _c("strong", [_vm._v("×")]),
      _vm._v(" to remove that option from the list. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }